import {
  Card,
  Group,
  Divider,
  Accordion,
  Text,
  Loader,
  Flex,
  Button,
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useGetStatementData } from 'api/resource';
import { DataBadge } from 'components/common';
import { Statement, Credit } from 'interfaces';
import { ReportDownloadButton } from 'pages/reports/components';

import { PaymentDetailsAccordion } from './PaymentDetailsAccordion';
import { DebitsModal } from './DebitsModal';
import { formatDateRange } from 'utils/dateUtils';

export const StatementCard = ({
  statement,
  loadingStatements,
}: {
  statement: Statement;
  loadingStatements: boolean;
}) => {
  const [opened, { open, close }] = useDisclosure();
  const s3Path = statement.statementPath;
  const { data, isLoading } = useGetStatementData({ s3Path });
  return (
    <Card shadow="sm" radius={'md'} withBorder m={'md'}>
      {loadingStatements ? (
        <Flex justify="center">
          <Loader />
        </Flex>
      ) : (
        <>
          <Group justify="space-between" mb="xs">
            <Text fw={500}>
              {statement.provider?.firstName +
                ' ' +
                statement.provider?.lastName}
            </Text>
            <Text size="sm" c="dimmed" style={{ textAlign: 'right' }}>
              Total Amount:{' '}
              <DataBadge>${Number(statement.totalAmount).toFixed(2)}</DataBadge>
            </Text>
            {statement.reportPath && (
              <ReportDownloadButton s3Path={statement.reportPath} />
            )}
          </Group>
          <Text size="sm" c="dimmed">
            {`Period: ${formatDateRange(
              statement.startDate,
              statement.endDate
            )}`}
          </Text>
          <Divider my="sm" />
          {isLoading ? (
            <Loader />
          ) : (
            <Accordion variant="separated">
              {data.statementCredits?.map((credit: Credit) => (
                <Accordion.Item value={`details-${credit.id}`} key={credit.id}>
                  <Accordion.Control>View Payment Details</Accordion.Control>
                  <Accordion.Panel>
                    <PaymentDetailsAccordion data={data} credit={credit} />
                  </Accordion.Panel>
                </Accordion.Item>
              ))}

              <Button
                style={{
                  width: '100%',
                  alignSelf: 'center',
                }}
                onClick={open}
              >
                View Claims ({data?.statementDebits?.length})
              </Button>
            </Accordion>
          )}
          {data && (
            <DebitsModal
              opened={opened}
              close={close}
              debits={data.statementDebits ?? []}
            />
          )}
        </>
      )}
    </Card>
  );
};
